const theme = {
  grayBase: '#242833',
  grayDarker: '#76768c',
  grayDark: '#b4b4c4',
  gray: '#d9d9e1',
  grayLight: '#f2f2f5',
  grayLighter: '#fafafc',
  brandDefault: '#242833',
  brandPrimary: '#2d5781',
  brandSecondary: '#f2f2f5',
  brandSuccess: '#2d5781',
  brandInfo: '#0066a6',
  brandWarning: '#ffa452',
  brandAlert: '#ff5252',

  bodyBackgroundColor: '#fafafc',

  fontFamilyBase: 'Montserrat, Helvetica Neue, Helvetica, sans-serif',
  fontSizeBase: '14px',

  fontWeightLight: 300,
  fontWeightNormal: 400,
  fontWeightMedium: 500,
}

export default theme
